import { getOffset } from './utilities';
import { createPopper } from '@popperjs/core';

class Bubble {
  constructor(el, text) {
    this.el = el;
    this.text = text;
    el.addEventListener('click', this.toggleBubble.bind(this));
  }

  toggleBubble(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (this.el.classList.contains('helping')) {
      this.hideBubble(e);
    } else {
      document.querySelectorAll('.helping').forEach((el) => el.classList.remove('helping'));
      this.showBubble(e);
    }
  }

  showBubble(e) {
    if (!this.bubble) {
      this.bubble = document.createElement('div')
      let bubbleContent = document.createElement('p')
      bubbleContent.innerText = this.text;
      this.bubble.appendChild(bubbleContent);
      this.bubble.classList.add('bubble');
      this.el.appendChild(this.bubble);
      const cue = this.el.querySelector('.cue');
      if (cue) {
        const w = cue.clientWidth;
        const l = getOffset(cue).left + (w / 2);
        this.bubble.style.right = "";
        this.bubble.style.left = `${l - 89}px`;
      }
    }
    this.el.classList.add('helping');
    document.addEventListener('click', this.hideBubble.bind(this));
  }

  hideBubble(e) {
    if (this.bubble) {
      this.el.classList.remove('helping');
    }
    document.removeEventListener('click', this.hideBubble.bind(this));
  }
}

function titleBubble(el) {
  let text = el.title;
  if (text) {
    el.removeAttribute('title');
    el.classList.add('helpable');
    if (!el.parentNode.querySelector('.cue')) {
      const ns = 'http://www.w3.org/2000/svg';
      const cue = document.createElementNS(ns, 'svg');
      const use = document.createElementNS(ns, 'use');
      use.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#info_symbol');
      cue.appendChild(use);
      cue.classList.add('cue');
      el.appendChild(cue);
    }
    new Bubble(el, text);
  }
}

class InfoWindow {
  constructor(el) {
    this.el = el;
    this.tooltip = document.querySelector(el.dataset.infowindow);
    this.popper = createPopper(this.el, this.tooltip, {
      placement: "right",
    });
    el.addEventListener('click', this.toggle.bind(this));
  }

  toggle(e) {
    if (this.tooltip.classList.contains('showing')) {
      this.hide(e);
    } else {
      this.show(e);
    }
  }

  show(e) {
    e.iwOpener = this;
    this.tooltip.classList.add('showing');
    document.addEventListener('click', this.hideUnlessOpening.bind(this));
  }

  // we want a click event to close any other infowindow that is open,
  // but not immediately to close this infowindow as it opens.
  hideUnlessOpening(e) {
    if (!e || !e.iwOpener || e.iwOpener !== this) {
      this.hide();
    }
  }

  hide(e) {
    this.tooltip.classList.remove('showing');
    document.removeEventListener('click', this.hide.bind(this));
  }
}

function infoWindow(el) {
  new InfoWindow(el);
}

export {
  titleBubble,
  infoWindow,
}